export default __webpack_public_path__ + "static/media/managet.068d3d6a.png";